import Link from "next/link";
import styles from "./HeaderNav.module.css";

import { HEADER_MAIN_LINKS } from "@/utils/utilsConst";
import { useShowNav } from "@/context/HeaderShowNav";

function HeaderNav({ isLight = false, children }) {
  const { showNav } = useShowNav();
  const navColor = isLight
    ? "var(--color-grey-100)"
    : "var(--color-primary-dark)";

  return (
    <nav
      className={`${styles.nav} ${showNav ? styles.isActive : ""}`}
      style={{ color: navColor }}
    >
      <ul>
        {HEADER_MAIN_LINKS.map((link) => (
          <li key={link.id}>
            <Link href={link.href}>{link.label}</Link>
          </li>
        ))}
      </ul>

      {/* <div className={styles.bgImg}>{children}</div> */}
    </nav>
  );
}

export default HeaderNav;
